const state = {
  userActive: false,
  touchDevice: false
}

const getters = {
}

const mutations = {
  UPDATE_USER_ACTIVE: (state, flag) => {
    state.userActive = flag
  },
  UPDATE_TOUCH_DEVICE: (state, flag) => {
    state.touchDevice = flag
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/general.js